import { AppShell } from "@mantine/core";
import React from "react";
import { Outlet } from "react-router-dom";
import { Header } from "../../components/layout/Header";
import { OperationsNav } from "../../components/layout/OperationsNav";

export const OperationsPanel: React.FC = () => {
  return (
    <AppShell header={{ height: 60 }} padding="md">
      <AppShell.Header>
        <Header />
      </AppShell.Header>
      <AppShell.Main>
        <OperationsNav />
        <Outlet />
      </AppShell.Main>
    </AppShell>
  );
};
